import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../store/index";
import buSlice from "../slices/BUSlice";
import BUService from "../../services/BUService";
import { BUModel } from "../../models/BUModel";

export const buActions = buSlice.actions;

export const fetchBUs = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch, getState) => {
    dispatch(buActions.setIsBUsFetching(true));
    const response: BUModel[] = await BUService.getAllBUs();
    dispatch(buActions.setBUs(response));
    dispatch(buActions.setIsBUsFetching(false));
  };
};

export const fetchBUsBySBU = (
  subName: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: BUModel[] = await BUService.getAllBUsBySBU(subName);
    dispatch(buActions.setBUsBySBU(response));
  };
};

export const fetchParticularBU = (
  bu_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: BUModel = await BUService.getParticularBU(bu_id);
    dispatch(buActions.setParticularBU(response));
  };
};
